import { AUTOMATED_COMMS_TABLE_KEYS } from "features/AutomatedCommunication/constants/AutomatedComms.constants";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";

export const shouldRenderCommsTable = (table) => {
  const { [AUTOMATED_COMMS_TABLE_KEYS.comms]: comms } = table;
  return !checkIsArrayEmpty(comms);
};
